// src/customer/customer-policy/customer-policy-commission/TransactionGroup.tsx

import React from "react";
import { Row, Column } from "../../../components";
import { ICommissionTransactionGroup } from "./models/CommissionTypes";
import DirectBillRecord from "./DirectBillRecord";
import CommissionReport from "./CommissionReport";
import ReconciledCard from "./ReconciledCard";
import NoRecordPlaceholder from "./NoRecordPlaceholder";

interface ITransactionGroupContentProps {
  group: ICommissionTransactionGroup;
}

const TransactionGroupContent: React.FC<ITransactionGroupContentProps> = ({
  group,
}) => {
  return (
    <Row>
      {/* Left Column: Direct Bill Record */}
      <Column lg={6} md={6} className="d-flex flex-column gap-3">
        {group.directBillRecord ? (
          <>
            <DirectBillRecord
              data={group.directBillRecord}
              transEffectiveDate={group.transEffectiveDate}
            />
            {group.reconciledRecord && (
              <ReconciledCard data={group.reconciledRecord} />
            )}
          </>
        ) : (
          <NoRecordPlaceholder date={group.transactionDate} />
        )}
      </Column>

      {/* Right Column: Commission Report */}
      <Column lg={6} md={6} className="d-flex flex-column gap-3">
        {group.commissionReport ? (
          <CommissionReport
            data={group.commissionReport}
            transEffectiveDate={group.transEffectiveDate}
          />
        ) : (
          <NoRecordPlaceholder date={group.transactionDate} />
        )}
      </Column>
    </Row>
  );
};

export default TransactionGroupContent;
